/* eslint-disable no-unused-vars */
import { useSelector } from "react-redux";
import { store } from "../store/index";
/**
 * @typedef {ReturnType<typeof store.getState>} StoreType
 */

/**
 * @type {import('react-redux').TypedUseSelectorHook<StoreType>}
 */
export const useAppSelector = useSelector;
